import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { CloseIcon, ColoredCancelIcon } from 'ui-component/custom-icons/icons'

import { toast } from 'react-hot-toast';
import { FaSpinner } from 'react-icons/fa';

// ✅ Clear
const SalesOrderCancelReservationModal = ({
    openPopup,
    salesOrderId,
    name,
    productId,
    colorId,
    backOrderId,
    colorName,
    quantity,
    handleClose,
    handleLoadSalesOrder
}) => {

    const [isFormDisabled, setIsFormDisabled] = useState(false);
    const [selectedQuantity, setSelectedQuantity] = useState(quantity);
    
    const submitForm = () => {
        if (selectedQuantity < 1) {
            toast.error('Please enter a valid quantity');
            return;
        }
        const request = {
            sales_order_id: salesOrderId,
            product_id: productId,
            backorder_id: backOrderId,
            quantity: selectedQuantity
        }
        setIsFormDisabled(true)
        toast.promise(
            api
                .cancelReservationFromSalesOrder(salesOrderId, request)
                .then(
                    (res) => {
                        setIsFormDisabled(false)
                        if (res.status) {
                            handleLoadSalesOrder()
                        }
    
                        return res?.status ? res : null;
                    },
                    () => { }
                ),
            {
                loading: 'Cancelling Reservation...',
                success: (data) => `${data.message}`,
                error: <b>Failed to cancel reservation</b>
            }
        );
    }


    return (
        <Modal show={openPopup}  centered size="sm">
            <Modal.Body>
                <div className="p-2">
                    <div>
                        <div className="mb-2 ml-0 pl-0">

                            <div className="row">
                                <div className="col-12 text-center">
                                    <ColoredCancelIcon height={'60px'} width={'60px'} />
                                </div>
                            </div>
                            <button className="btn modal-close-icon" onClick={handleClose}>
                                <CloseIcon height={'16px'} width={'16px'} />
                            </button>
                        </div>

                        <div className="row align-items-top">
                            <div className="col-12 text-center " style={{ padding: '10px 0 10px 0' }}>
                                <div style={{ fontSize: '24px' }}>
                                    Cancel Reservation
                                </div>
                                <div className="text-gray-800">
                                    Cancel product reservation for this order
                                </div>
                                
                            </div>
                        </div>
                        <div className="row align-items-top">
                            <div className="col-12 text-left " style={{ padding: '10px 0' }}>
                                <div>
                                    Product Name:
                                    <div>{name} {colorName}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-top">
                            <div className="col-12 text-left " style={{ padding: '10px 0' }}>
                                <div>
                                    Available Quantity:
                                    <div>QTY: <span className="fw-500 text-green-700">{quantity}</span></div>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-top">
                            <div className="col-12 text-left " style={{ padding: '10px 0' }}>
                                <label>Quantity to cancel</label>
                                
                                <input
                                    type="number"
                                    className={`form-control ${isFormDisabled ? 'disabled' : ''}`}
                                    min={0}
                                    max={quantity}
                                    value={selectedQuantity}
                                    defaultValue={quantity}
                                    onChange={(e) => {
                                        let val = Number(e.target.value);
                                        if (val > quantity) {
                                            setSelectedQuantity(quantity);
                                        } else if (val < 1) {
                                            setSelectedQuantity(1);
                                        } else {
                                            setSelectedQuantity(val);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row align-items-top">
                            <div className="col-12 text-left " style={{ padding: '20px 0px 0px 0px' }}>
                                
                                <button
                                    className={`${(isFormDisabled) && 'disabled' } btn btn-block btn-main-primary btn-outlined-main-primary`}
                                    disabled={isFormDisabled}
                                    onClick={() => {
                                        if (!isFormDisabled) {
                                            submitForm()
                                        }
                                    }}
                                >
                                    {
                                        isFormDisabled ? (
                                            <>
                                                <FaSpinner className="fa-spin" /> Processing...
                                            </>
                                        ) : (
                                            'Proceed'
                                        )
                                    }
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SalesOrderCancelReservationModal;
